import { ChannelType } from 'src/legacy/components/Channels/useChannelForm';

import { AppNotificationBadge } from './AppNotificationBadge';

import {
  ContractNotificationsBadge,
  FilesNotificationBadge,
  FormsNotificationsBadge,
  InboxNotificationBadge,
  InvoiceNotificationsBadge,
  MessagesNotificationBadge,
} from '.';

export const useNotificationsBadge = (
  entityType: ChannelType | 'customApp',
  appId?: string,
) => {
  switch (entityType) {
    case 'messaging':
      return <MessagesNotificationBadge />;
    case 'files':
      return <FilesNotificationBadge />;
    case 'forms':
      return <FormsNotificationsBadge />;
    case 'contracts':
      return <ContractNotificationsBadge />;
    case 'billing':
      return <InvoiceNotificationsBadge />;
    case 'inbox':
      return <InboxNotificationBadge />;
    case 'customApp':
      return appId ? <AppNotificationBadge appId={appId} /> : null;
    default:
      return null;
  }
};
